module.exports = __webpack_public_path__ + "img/11.a9861b00.png";